import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import './Tabs.scss';

export const TabItem = ({icon, count, ...props}) => (
  <div {...props}>
    {icon && <span className='tab-item__icon'>{icon}</span>}
    {count && <span className='tab-item__count'>{count}</span>}
    {props.children}
  </div>
);

TabItem.propTypes = {
  icon: PropTypes.element,
  count: PropTypes.number,
  children: PropTypes.node
};

export const Tabs = ({
                       className = '',
                       defaultIndex = '0',
                       onTabClick,
                       children,
                       changeTabIndex,
                     }) => {
  const [bindIndex, setBindIndex] = useState(defaultIndex);

  const changeTab = (newIndex) => {
    if (typeof onTabClick === 'function') onTabClick(newIndex);
    setBindIndex(newIndex);
  };

  useEffect(() => {
    let isMounted = true;

    if (isMounted && changeTabIndex !== undefined) {
      setBindIndex(changeTabIndex);
    }

    return () => {
      isMounted = false;
    };
  }, [changeTabIndex]);

  const items = React.Children.toArray(children).filter((child) => child.type === TabItem);

  return (
      <div className={`tabs${className ? ` ${className}` : ''}`}>
        <div className='tabs__menu'>
          {items.map(({ props: { index, label, hidden, icon, count, notification } }, _) =>
              !hidden ? (
                  <button
                      key={`tab-btn-${index}`}
                      className={`tabs__btn${bindIndex === index ? ' tabs__btn--active' : ''}`}
                      type='button'
                      role='tab'
                      onClick={() => changeTab(index)}
                  >
                    {icon && <div className='tabs__btn-icon'>{icon}</div>}
                    <div className='tabs__btn-info'>
                      {label}
                      <div className='tabs__btn-count'>{count}</div>
                      {notification !== 0 ? <div className='tabs__btn-notification'>{notification}</div> : null}
                    </div>
                  </button>
              ) : null
          )}

        </div>
        <div className='tabs__panel'>
          {items.map(({ props }, _) =>
              bindIndex === props.index ? (
                  <div
                      key={`tab-item-${props.index}`}
                      className='tabs__item tabs__item--active'
                  >
                    {props.children}
                  </div>
              ) : null
          )}

        </div>
      </div>
  );
};

Tabs.propTypes = {
  className: PropTypes.string,
  defaultIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onTabClick: PropTypes.func,
  changeTabIndex: PropTypes.string,
  children: PropTypes.node.isRequired
};
